<div class="flex items-center mb-8">
  <!-- Header -->
  <div class="flex flex-col flex-grow">
    <span class="text-2xl font-bold">Welcome, {{ userName }}</span>
    <span class="text-base">{{ userOrganization }}</span>
  </div>

  <!-- Nav -->
  <div class="trial-insights-nav-container">
    <a
      class="trial-insights-nav"
      *ngIf="showClinOpsButton$ | async"
      [routerLink]="clinicalRouterLink"
      [routerLinkActive]="['active']"
    >
      ClinOps
    </a>

    <a
      class="trial-insights-nav"
      *ngIf="showFinanceButton$ | async"
      [routerLink]="financeRouterLink"
      [routerLinkActive]="['active']"
    >
      Finance
    </a>
  </div>
</div>
